import { Box, Paper, Typography, Button, Stack } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';

export function Unauthorized({ message }: { message: string }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', p: 3, bgcolor: 'background.default' }}>
      <Paper elevation={3} sx={{ p: 6, maxWidth: 560, textAlign: 'center', borderRadius: 3 }}>
        <LockIcon sx={{ fontSize: 72, color: 'error.main', mb: 2 }} />
        <Typography variant="h3" sx={{ mb: 2 }}>Access Required</Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          {message}
        </Typography>
        <Stack spacing={2} direction={{ xs: 'column', sm: 'row' }} justifyContent="center">
          <Button
            variant="contained"
            size="large"
            href="mailto:mohanj@softura.com?subject=Workshop%20Planner%20access%20request"
          >
            Email mohanj@softura.com
          </Button>
          <Button variant="outlined" size="large" href="/logout">
            Sign out
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
}
